import { UserRoleAction  } from '../types/UserRoleAction';
import { UserRoleBody } from '../types/UserRolesBody';
import { rolesEnum} from '../types/RolesEnumBody'

interface UserRolesState {
    list: UserRoleBody[],
    error: string,
    count: number,
    enumList:rolesEnum[]
  };
  
  const initialState: UserRolesState = {
    list: [],
    error: "",
    count: 0,
    enumList:[]
  };


const userRoleReducer = (state = initialState, action: UserRoleAction) => {
    switch (action.type) {
      case 'UserRole_List_SUCCESS': {
        return { ...state, list: action.data }
      }
      case 'UserRole_List_FAILED': {
        return { ...state, error: action.error }
      }
      case 'UserRole_List_COUNT_SUCCESS': {
        return { ...state, count: action.data }
      }
      case 'UserRole_Enum_SUCCESS': {
        return { ...state, enumList: action.data }
      }
      case 'UserRole_ADD_SUCCESS': {
        let list =[...state.list ,action.data ]
        return { ...state, list,count: state.count+1 }
      }
      default:
        return state;
    }
  }


export default userRoleReducer;